
<template>
<div class="position-container">
  <el-tooltip placement="bottom" effect="light">
    <div class="tip-wrap" slot="content">
      <label>老师好~,您可以在这里切换您的校内角色.</label>
    </div>
    <i @click="openPositionDialog" style="font-size:28px;cursor: pointer;color:#409EFF;" class="iconfont icon-jiaoseleixing"></i>
  </el-tooltip>
  <el-dialog
    title="选择校内角色"
    :visible.sync="visible"
    width="555px"
    :show-close="enableClose"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="initDialog">
    <div class="dialog-panel">
      <div class="oprate-wrap">
         <el-checkbox v-model="setDefault">将选择的角色设为默认</el-checkbox>
        <span style="margin-left:20px;" v-if="currentPosition">您当前的角色：{{currentPosition.positionName}}</span>
      </div>
      <div class="position-wrap">
        <div v-for="position of postionsList" :key="position.positionCode" @click="setCurrentPosition(position)" class="position-item">
          <i  style="color:#469046;font-size:50px;cursor: pointer;" class="iconfont icon-kehuguanli"></i>
          <span class="mobile-label">{{position.positionName}}{{position.subjectId?`-${position.subjectName}`:''}}</span>
        </div>
        <p v-if="postionsList.length === 0" class="no-role-tips">您的账号暂未设置任教科目或年级信息, 请联系上级账号补全信息后再使用</p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" :disabled="!enableClose" @click="handleClose" class="footer-btn">关 闭</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import common from '@/util/common'
export default {
  name: 'SchoolUserPosition',
  data () {
    return {
      postionsList: [],
      setDefault: true
    }
  },
  mounted () {
    this.initDialog()
  },
  computed: {
    schoolPositionList () {
      return this.$store.state.user.schoolPositionList
    },
    currentPosition () {
      return this.$store.getters.userSchoolPosition
    },
    userInfo () {
      return common.getUserInfo()
    },
    visible () {
      return this.$store.state.user.positionVisible
    },
    enableClose () {
      return this.$store.state.user.poistionDialogEnableClose
    }
  },
  methods: {
    handleTipClose () {
      this.tipDisabled = true
    },
    openPositionDialog (dialogStatus) {
      this.$store.commit('SHOW_CHOOSE_POSITION', {
        positionVisible: true,
        enableClose: true
      })
    },
    handleClose () {
      this.$store.commit('SHOW_CHOOSE_POSITION', {
        positionVisible: false,
        enableClose: true
      })
    },
    setCurrentPosition (position) {
      let userId = this.userInfo.userId
      this.$store.dispatch('setCurrentPosition', position)
      if (this.setDefault) {
        this.$store.dispatch('setDefaultPosition', {userId, position})
      }
      console.log('setCurrentPosition', position)
      window.location.href = '/exam'
    },
    initDialog () {
      console.log('initDialog')
      this.postionsList.splice(0, this.postionsList.length)
      for (let position of this.schoolPositionList) {
        let index = this.postionsList.findIndex((tempPosition) => {
          return tempPosition.positionCode === position.positionCode && tempPosition.subjectId === position.subjectId
        })
        let tmpClassObject = {
          classId: position.classId,
          grade: position.gradeLevel,
          classCode: position.classCode,
          className: position.className
        }
        if (index === -1) {
          this.postionsList.push({
            ...position,
            positionName: common.getPostionNameByCode(position.positionCode),
            gradeLevels: [position.gradeLevel],
            classIds: [position.classId],
            classes: [tmpClassObject]
          })
        } else {
          this.postionsList[index].gradeLevels.push(position.gradeLevel)
          this.postionsList[index].classIds.push(position.classId)
          this.postionsList[index].classes.push(tmpClassObject)
        }
      }
      console.log(this.postionsList)
    }
  }
}
</script>

<style lang="scss" scoped>

.position-container {
  display: flex;
  width: 50px;
  justify-content: center;
  align-items: center;
  .tip-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    height: 10px;
  }
  .dialog-panel {
    display: flex;
    height: 300px;
    flex-direction: column;
    .position-wrap{
      display: flex;
      margin-top: 60px;
      .position-item {
        display: flex;
        height: 100px;
        width: 118px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
    .no-role-tips{
      color: red;
      font-size: 22px;
      font-weight: bold;
      line-height: 2;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/custom/SchoolUserPosition.vue